import { useLayoutEffect, useState } from "react"
import PropTypes from "prop-types"

const useFloatingShowMore = (containerRef, deps = []) => {
  const [showSeeMore, setShowSeeMore] = useState(false)

  const checkScroll = () => {
    if (!containerRef.current) return
    const el = containerRef.current
    const isScrollable = el.scrollHeight > el.clientHeight
    const isScrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight
    setShowSeeMore(isScrollable && !isScrolledToBottom)
  }

  useLayoutEffect(() => {
    const el = containerRef.current
    if (!el) return

    checkScroll()
    el.addEventListener("scroll", checkScroll)
    window.addEventListener("resize", checkScroll)

    return () => {
      el.removeEventListener("scroll", checkScroll)
      window.removeEventListener("resize", checkScroll)
    }
  }, [containerRef, ...deps])

  return showSeeMore
}

export default useFloatingShowMore

useFloatingShowMore.propTypes = {
  containerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  deps: PropTypes.array,
}
